import { awaitqeg6zusi9ora as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ReactiveMutableSet2bktc9g3zyrtk as ReactiveMutableSet } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableSet.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { multiselectp8aawqh86psn as multiselect } from '../components/Multiselect.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nij_1.mij_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var ids = tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.nij_1.hij_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (ids.t1(element.mf9_1)) {
      destination.v(element);
    }
  }
  var selection = destination;
  var tmp_0 = $this.nij_1.lij_1(selection, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().pgd();
  return Unit_instance;
}
function MultiselectFromItemsDialog$_init_$lambda_qnb7xa(it) {
  return it === 0 ? 'Select Items' : 'Select (' + it + ') Items';
}
var MultiselectFromItemsDialog$render$slambdaClass;
function MultiselectFromItemsDialog$render$slambda() {
  if (MultiselectFromItemsDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MultiselectFromItemsDialog$render$slambdaClass = $;
  }
  return MultiselectFromItemsDialog$render$slambdaClass;
}
function MultiselectFromItemsDialog$render$slambda_0() {
  var i = new (MultiselectFromItemsDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MultiselectFromItemsDialog$render$slambdaClass_0;
function MultiselectFromItemsDialog$render$slambda_1() {
  if (MultiselectFromItemsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.oij_1 = this$0;
      }
      wg8(query, $completion) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.oij_1.hij_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (contains(element.nf9_1, query)) {
            destination.v(element);
          }
        }
        return destination;
      }
      s2(p1, $completion) {
        return this.wg8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    MultiselectFromItemsDialog$render$slambdaClass_0 = $;
  }
  return MultiselectFromItemsDialog$render$slambdaClass_0;
}
function MultiselectFromItemsDialog$render$slambda_2(this$0) {
  var i = new (MultiselectFromItemsDialog$render$slambda_1())(this$0);
  var l = (query, $completion) => i.wg8(query, $completion);
  l.$arity = 1;
  return l;
}
function MultiselectFromItemsDialog$render$lambda(it) {
  return it.mf9_1;
}
function MultiselectFromItemsDialog$render$lambda_0(it) {
  return it.nf9_1;
}
var MultiselectFromItemsDialog$render$slambdaClass_1;
function MultiselectFromItemsDialog$render$slambda_3() {
  if (MultiselectFromItemsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MultiselectFromItemsDialog$render$slambdaClass_1 = $;
  }
  return MultiselectFromItemsDialog$render$slambdaClass_1;
}
function MultiselectFromItemsDialog$render$slambda_4() {
  var i = new (MultiselectFromItemsDialog$render$slambda_3())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var MultiselectFromItemsDialog$render$slambdaClass_2;
function MultiselectFromItemsDialog$render$slambda_5() {
  if (MultiselectFromItemsDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.nij_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MultiselectFromItemsDialog$render$slambdaClass_2 = $;
  }
  return MultiselectFromItemsDialog$render$slambdaClass_2;
}
function MultiselectFromItemsDialog$render$slambda_6(this$0) {
  var i = new (MultiselectFromItemsDialog$render$slambda_5())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MultiselectFromItemsDialogClass;
function MultiselectFromItemsDialog() {
  if (MultiselectFromItemsDialogClass === VOID) {
    class $ {
      constructor(options, header, confirmText, cancelText, onSubmit) {
        var tmp;
        if (confirmText === VOID) {
          tmp = MultiselectFromItemsDialog$_init_$lambda_qnb7xa;
        } else {
          tmp = confirmText;
        }
        confirmText = tmp;
        cancelText = cancelText === VOID ? 'Go Back' : cancelText;
        this.hij_1 = options;
        this.iij_1 = header;
        this.jij_1 = confirmText;
        this.kij_1 = cancelText;
        this.lij_1 = onSubmit;
        this.mij_1 = ReactiveMutableSet().bao();
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(MultiselectFromItemsDialog$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp = view.kbb(get_centered(view), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        var tmp_0 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(40));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().zg1_1);
        title(view_1, this.iij_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Work Items';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(false);
        view_3.bb9(get_AppDimensions().rg2_1);
        view_3.lbb(get_centered(view_3), bodyBold(view_3, label));
        view_3.lbb(colored(view_3, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_3, '*'));
        view_2.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_2.jbb(FieldSemantic_getInstance());
        var tmp0_items = this.mij_1;
        var tmp_2 = MultiselectFromItemsDialog$render$slambda_2(this);
        var tmp_3 = ($this$multiselect, id) => {
          var tmp0 = this.hij_1;
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.collections.first' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.mf9_1.equals(id)) {
                tmp$ret$6 = element;
                break $l$block;
              }
            }
            throw NoSuchElementException().o('Collection contains no element matching the predicate.');
          }
          return tmp$ret$6;
        };
        var tmp_4 = MultiselectFromItemsDialog$render$lambda;
        var tmp$ret$7 = multiselect(view_2, tmp_2, tmp_3, tmp_4, 'Select one or multiple items to be modified', MultiselectFromItemsDialog$render$lambda_0, VOID, tmp0_items);
        view_2.lbb(tmp_1, tmp$ret$7);
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_5 = get_secondaryButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        specCenteredText(view_5, this.kij_1);
        onClick(view_5, 'Cancel', VOID, MultiselectFromItemsDialog$render$slambda_4());
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_5, view_5);
        var tmp_6 = get_primaryButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.gbb(p_6, view_6);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Button$_get_enabled_$ref_61t7nx(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          var tmp$ret$17 = !$this$reactiveScope.daj(this.mij_1).i1();
          this_0.set(tmp$ret$17);
          return Unit_instance;
        });
        specCenteredText_0(view_6, ($this$specCenteredText) => {
          // Inline function 'kotlin.collections.count' call
          var tmp$ret$19 = $this$specCenteredText.daj(this.mij_1).p1();
          return this.jij_1(tmp$ret$19);
        });
        onClick(view_6, 'Submit selection', VOID, MultiselectFromItemsDialog$render$slambda_6(this));
        view_4.hbb(p_6, view_6);
        view_4.lbb(tmp_6, view_6);
        view_1.hbb(p_4, view_4);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'MultiselectFromItemsDialog', VOID, VOID, [Page()]);
    MultiselectFromItemsDialogClass = $;
  }
  return MultiselectFromItemsDialogClass;
}
//region block: exports
export {
  MultiselectFromItemsDialog as MultiselectFromItemsDialog1wktb030y4ov,
};
//endregion

//# sourceMappingURL=SelectFromItemsDialog.mjs.map
